import React from 'react';
import styled, { css } from 'styled-components';

import { Nullable } from '@tager/web-core';
import { ThumbnailType } from '@tager/web-modules';

interface Props {
  avatar: ThumbnailType;
  authorName: Nullable<string>;
  authorText: Nullable<string>;
}

function Author({ avatar, authorName, authorText }: Props) {
  return (
    <Component>
      <Photo photo={avatar.url} />
      <Content>
        <Name>{authorName}</Name>
        <Info>{authorText}</Info>
      </Content>
    </Component>
  );
}

export default Author;

const Component = styled.div`
  display: flex;
  align-items: center;
`;

const Photo = styled.div<{ photo: Nullable<string> }>`
  overflow: hidden;

  width: 52px;
  height: 52px;

  margin-right: 10px;

  background: #c4c4c4;
  border-radius: 100%;

  @media (min-width: 1400px) {
    width: 80px;
    height: 80px;
    margin-right: 20px;
  }

  ${({ photo }) =>
    photo &&
    css`
      background-image: url('${photo}');
      background-repeat: no-repeat;
      background-position: center center;
      background-size: cover;
    `};
`;

const Content = styled.div``;

const Name = styled.span`
  font-weight: 300;
  display: block;
  font-size: 16px;
  line-height: 140%;
  color: ${(props) => props.theme.black100};

  @media (min-width: 1400px) {
    font-size: 21px;
  }
`;

const Info = styled.span`
  font-weight: 700;
  display: block;
  font-size: 12px;
  line-height: 140%;
  color: ${(props) => props.theme.black100};

  @media (min-width: 1400px) {
    font-size: 21px;
  }
`;
